module.exports = __webpack_public_path__ + "img/pdf_1.2226f98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/pdf_1.png
// module id = PyGf
// module chunks = 0 2 3 7 12 13 14 17 26 28 32 34 52